import styled from 'styled-components';

import { breakpoints, colors } from '../../constants';
import { Button } from '../Button';
import { useState } from 'react';

interface ISelectButton {
    selected: boolean;
}

const ButtonContainer = styled.div``;
const SelectButton = styled(Button)<ISelectButton>`
    background-color: ${({ selected }) =>
        selected ? colors.black : colors.white};
    color: ${({ selected }) => (selected ? colors.white : colors.black)};
    transition: all 0.15s linear;

    :hover {
        background-color: ${({ selected }) =>
            selected ? colors.black : colors.greyHover};
    }
`;

interface IProps {
    className?: string;
    selectedOption: string;
    setContactPreference(option: string): void;
}

const BaseContactPreferenceSelector = ({
    className,
    selectedOption,
    setContactPreference,
}: IProps) => {
    const [selectNoneButton, setSelectNoneButton] = useState(false);

    const handleSelectButtonClick = (option: string) => {
        setContactPreference(option);

        option === '' ? setSelectNoneButton(true) : setSelectNoneButton(false);
    };

    return (
        <div className={className}>
            <h3>
                Ik wens bij voorkeur <strong>gecontacteerd</strong> te worden
                via:
            </h3>
            <ButtonContainer>
                <SelectButton
                    selected={selectedOption === 'EMAIL'}
                    onClick={() => handleSelectButtonClick('EMAIL')}
                >
                    E-mail
                </SelectButton>
                <SelectButton
                    selected={selectedOption === 'PHONE'}
                    onClick={() => handleSelectButtonClick('PHONE')}
                >
                    Telefoon
                </SelectButton>
                <SelectButton
                    selected={selectNoneButton}
                    onClick={() => handleSelectButtonClick('')}
                >
                    Geen voorkeur
                </SelectButton>
            </ButtonContainer>
        </div>
    );
};

export const ContactPreferenceSelector = styled(BaseContactPreferenceSelector)`
    h3 {
        margin-bottom: 24px;
    }

    ${Button} {
        margin-bottom: 10px;
    }

    @media (${breakpoints.mediumMin}) {
        ${ButtonContainer} {
            display: inline-flex;
        }

        ${Button} {
            margin-left: 10px;
        }

        ${Button}:first-of-type {
            margin-left: 0;
        }
    }
`;
